import { Heading } from "@planningcenter/doxy-web"
import { array, bool, number, shape, string } from "prop-types"
import NamedAttendeeForm from "./NamedAttendeeForm"

const NamedAttendeeForms = ({ attendeeSummary }) => {
  const {
    requiredForms,
    hasPubliclyAvailableAttendeeInfoQuestions,
    missingFormIds,
    canEditAttendee,
    id: attendeeId,
    registrationId,
    formsCount,
    attendeeInfoQuestionsStatus,
  } = attendeeSummary

  const hasForms = formsCount && formsCount > 0
  const hasAttendeeInfoForm = hasPubliclyAvailableAttendeeInfoQuestions

  if (!hasForms && !hasAttendeeInfoForm) {
    return null
  }

  return (
    <div>
      <div className="mt-3">
        <Heading level={3} size={4} text="Additional Forms" />
      </div>
      {hasForms &&
        requiredForms.map((form) => {
          const remoteUrl = form.attendeeRemoteUrl || form.remoteUrl
          const attachmentUrl = form?.attachment?.url

          if (remoteUrl || attachmentUrl) {
            return (
              <NamedAttendeeForm
                key={form.id}
                title={form.name}
                href={remoteUrl || attachmentUrl}
                complete={!missingFormIds.includes(form.id)}
                disabled={remoteUrl && !form.canAccessRemoteUrl}
                disabledMessage="Only household members can edit this form."
              />
            )
          } else {
            return null
          }
        })}
      {hasAttendeeInfoForm && (
        <NamedAttendeeForm
          title="Attendee Information"
          href={
            canEditAttendee
              ? `/registrations/registrations/${registrationId}/attendee_info/${attendeeId}`
              : null
          }
          complete={attendeeInfoQuestionsStatus != "incomplete"}
          disabled={!canEditAttendee}
          disabledMessage="Only household members can edit this form."
        />
      )}
    </div>
  )
}

NamedAttendeeForms.propTypes = {
  attendeeSummary: shape({
    requiredForms: array,
    hasPubliclyAvailableQuestions: bool,
    hasPubliclyAvailableAttendeeInfoQuestions: bool,
    questionsStatus: string,
    attendeeInfoQuestionsStatus: string,
    profileInfoStatus: string,
    missingFormIds: array,
    canEditAttendee: bool,
    id: number,
    registrationId: number,
    formsCount: number,
  }),
}

export default NamedAttendeeForms
